import { ItemCardContainer } from "@/components/ItemCard";
import { DrawingCard } from "@/features/drawings/cards/DrawingCard";
import { type DesignsInfo } from "@repo/api";
import { Skeleton } from "@repo/skapa";

import { useSearchDesignById } from "../hooks/search";
import { NotFoundDrawingCard } from "./NotFoundDrawingCard";

export const DesignItem = ({
  editable,
  designInfo,
  onDisassociate,
  drawingInLoading,
}: {
  editable: boolean;
  designInfo: DesignsInfo;
  onDisassociate?: (drawingId: string) => void;
  drawingInLoading?: string;
}) => {
  const { data: designs, isValidating } = useSearchDesignById(
    designInfo.designId,
    designInfo.applicationId
  );

  if (isValidating || drawingInLoading === designInfo.designId) {
    return (
      <ItemCardContainer>
        <Skeleton data-testid="loading-design" height="115px" width="100%" />
      </ItemCardContainer>
    );
  }

  if (!designs) {
    return (
      <NotFoundDrawingCard
        editable={editable}
        onDisassociate={onDisassociate}
        drawingId={designInfo.designId}
      />
    );
  }

  return (
    <DrawingCard
      editable={editable ?? false}
      drawingInfo={designs}
      onDisassociate={onDisassociate}
      isVpDrawingValidating={false}
    />
  );
};
